// extracted by mini-css-extract-plugin
export default {"container":"ip-z","ratingLayout":"jp-z","ratingLabel":"kp-z","nonInteractiveRatingLabel":"lp-z"};